<template>
  <div class="bind-location-item-bd ubv ub-f1">
    <div class="ub" style="margin-bottom: 24px">
      <el-button type="warning" style="margin-right: 6px" @click="onBindEvent" v-if="funcView.depuser_dep_add_location">
        <i class="icon icon-tianjia"></i>
        <span>&ensp;{{ $t('Common.com_added') }}</span>
      </el-button>
      <el-button style="margin-right: 16px" :disabled="!tableSelect.length" @click="onUnbindEvent" v-if="funcView.depuser_dep_remove_location">
        <i class="icon icon-shanchu"></i>
        <span>&ensp;{{ $t('bind_location_item.yi_chu') }}</span>
      </el-button>
      <div class="ub-f1" style="margin-right: 12px">
        <search-input width="100%" :placeholder="$t('bind_location_item.gong_si_ming_cheng')" v-model="formSearch.orgName" @fetch="onPageChange({ page: 1 })"></search-input>
      </div>
      <div class="ub-f1">
        <search-input width="100%" :placeholder="$t('Common.com_location_name')" v-model="formSearch.locationName" @fetch="onPageChange({ page: 1 })"></search-input>
      </div>
    </div>
    <div class="table-bd ub-f1">
      <custom-table height="100%" stripe type="checkbox" tableCode="portal_department_location" v-model="tableSelect" :data="tableList"></custom-table>
    </div>
    <div class="table-page">
      <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
    </div>
    <!-- 分配设备 -->
    <bind-location-dialog v-if="dialogVisible" :model="dialogModel" :organ="organ" @close="dialogVisible = false" @success="getLocationList()"></bind-location-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import bindLocationDialog from './bind_location_dialog.vue';

export default {
  name: 'bind_location_item',
  components: { bindLocationDialog },
  props: {
    organ: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogModel: {},
      formSearch: {
        search: '',
        bizId: '',
        bizType: '',
        locationName: '',
        orgName: '',
        parentId: '',
        isAss: 1,
        pageSize: 50,
        pageNum: 1,
      },
      tableSelect: [],
      tableList: [],
      totalRows: 0,
    };
  },
  watch: {
    organ: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.tableList = [];
      this.totalRows = 0;
      this.getLocationList();
    },
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getLocationList();
    this.getFuncView();
  },
  methods: {
    // 获取关联项目
    getLocationList: function () {
      if (!this.organ.bizId) {
        return;
      }
      this.formSearch.bizId = this.organ.bizId;
      this.formSearch.bizType = this.organ.bizType;
      this.formSearch.parentId = this.organ.orgId;
      this.$getJSON(apis.deviceLocationPage, this.formSearch).then((res) => {
        this.tableList = res.data.list || [];
        this.totalRows = res.data.total;
      });
    },
    // 取消关联项目
    onUnbindEvent: function () {
      this.$showConfirm(this, this.$t('bind_location_item.nqdyjxzdxmcxzdbmzyc'))
        .then(() => {
          const params = this.tableSelect.map(t => ({
            orgId: this.orgId,
            bizId: this.organ.bizId,
            bizType: this.organ.bizType,
            toBizId: t.locationId,
            toBizType: 4,
          }));
          this.$postJSON(apis.organDeviceBindAutoDel, params).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getLocationList();
          });
        })
        .catch(() => {});
    },
    // 添加项目
    onBindEvent: function () {
      this.dialogModel = {
        title: this.$t('bind_location_item.tian_jia_xiang_mu'),
        organ: this.organ,
      };
      this.dialogVisible = true;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getLocationList();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
</style>
